import {LineItemTransitions} from "./lineItemTransitions";

export const DefaultCancellationReasonEmailTemplates = {
    [LineItemTransitions.CANCEL]: ['item_cancelled'],
    [LineItemTransitions.UNAVAILABLE]: ['item_cancelled'],
    [LineItemTransitions.RETURN_RUNNER]: ['order_open_return']
}
